import React from 'react';
import { GiftIcon, CheckCircleIcon, StarIcon, BellIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
export function NotificationsScreen() {
  const navigate = useNavigate();
  const notifications = [{
    id: '1',
    type: 'promo',
    icon: GiftIcon,
    iconBg: 'bg-[#c7f61e]',
    badge: 'PROMO',
    badgeColor: 'bg-[#c7f61e] text-[#1f5070]',
    headline: 'Special Weekend Offer!',
    message: 'Get 20% off all bookings this Saturday & Sunday',
    time: '2 hours ago',
    unread: true,
    action: () => navigate('/promotion')
  }, {
    id: '2',
    type: 'booking',
    icon: CheckCircleIcon,
    iconBg: 'bg-[#3dc7e3]',
    badge: 'BOOKING',
    badgeColor: 'bg-[#3dc7e3] text-white',
    headline: 'Booking Confirmed - Court A',
    message: 'Tomorrow at 3:00 PM. Show QR code at check-in',
    time: '1 day ago',
    unread: false,
    action: () => navigate('/bookings/confirmation/ABC123')
  }, {
    id: '3',
    type: 'feature',
    icon: StarIcon,
    iconBg: 'bg-[#c7f61e]',
    badge: 'NEW FEATURE',
    badgeColor: 'bg-[#c7f61e] text-[#1f5070]',
    headline: 'Earn UniPlay Credits!',
    message: 'Book 5 times and get 100 UC free',
    time: '3 days ago',
    unread: false,
    action: () => navigate('/promotion')
  }];
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-635">
      <Header title="Notifications" showBack={true} onBack={() => navigate('/home')} actionButton={<button className="text-sm text-[#3dc7e3] font-bold" data-id="element-637">
            Mark all read
          </button>} data-id="element-636" />

      <div className="flex-1 overflow-auto px-4 py-4 space-y-3" data-id="element-638">
        {notifications.map(notification => {
        const Icon = notification.icon;
        return <button key={notification.id} onClick={notification.action} className="w-full bg-white rounded-xl shadow-md p-4 flex gap-4 active:scale-98 transition-transform text-left relative" data-id="element-639">
              {/* Unread indicator */}
              {notification.unread && <div className="absolute left-2 top-1/2 -translate-y-1/2 w-2 h-2 bg-[#3dc7e3] rounded-full" data-id="element-640"></div>}

              {/* Icon */}
              <div className={`w-10 h-10 ${notification.iconBg} rounded-full flex items-center justify-center flex-shrink-0`} data-id="element-641">
                <Icon className="w-5 h-5 text-[#1f5070]" data-id="element-642" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-643">
                <div className="flex items-center gap-2 mb-1" data-id="element-644">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${notification.badgeColor}`} data-id="element-645">
                    {notification.badge}
                  </span>
                  <span className="text-xs text-gray-400" data-id="element-646">
                    {notification.time}
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1f5070] mb-1" data-id="element-647">
                  {notification.headline}
                </h3>
                <p className="text-sm text-[#666666]" data-id="element-648">{notification.message}</p>
              </div>
            </button>;
      })}
      </div>

      <BottomNav data-id="element-649" />
    </div>;
}